var scrollBody = $('body');

function scrollToSection(sectionClass) {
    var sectionPos = $('.'+sectionClass).offset().top;
    scrollBody.animate({
        scrollTop: sectionPos
    }, 1000);
    return false;
}

$('.mt_header_link').add('.mt_logo_link').add('.mt_button_scroll').on('click', function(e) {
    e.preventDefault();
    var sectionClass = $(this).attr('data-url');
    scrollToSection(sectionClass);
});